<template>
  <v-container>
    <v-card>
      <v-card-title class="headline" style="margin-bottom:10px">Clock In</v-card-title>
    </v-card>
    <v-card>
      <v-dialog v-model="completeDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Clock In Successful</v-card-title>
          <v-card-text>You have successfully managed to clock in.<!--<span v-if="modules.jobEntry">Would you like to add job details?</span>--></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat to="/">OK</v-btn>
            <!-- <v-btn v-if="modules.jobEntry" color="green darken-1" flat to="/JobDetails">Yes</v-btn> -->
            <!-- <v-btn v-if="modules.jobEntry" color="red darken-1" flat to="/">No</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="errorDialog" persistent>
        <v-card>
          <v-card-title class="headline">Offline</v-card-title>
          <v-card-text>
            <v-alert v-model="errorDialog" icon="cloud_off" type="error">You are currently offline, Please try again later</v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat to="/">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="errorDateDialog" persistent>
        <v-card>
          <v-card-title class="headline">Shift Conflict</v-card-title>
          <v-card-text>
            <v-alert v-model="errorDateDialog" icon="mdi-clock-alert" type="error">You have already clocked in with this start time</v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat to="/">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-container>
        <v-form v-model="formValid" ref="form" lazy-validation>
          <v-dialog
            ref="dateDialog"
            persistent
            v-model="dateDialog"
            lazy
            full-width
            width="290px"
            :return-value.sync="date"
            :disabled="disableTimeChangeIn"
          >
            <v-text-field
              slot="activator"
              label="Start Date"
              v-model="formatDate"
              prepend-icon="event"
              readonly
              :rules="timeRules"              
              :disabled="disableTimeChangeIn"
            ></v-text-field>
            <v-date-picker v-model="date" actions full-width>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="dateDialog = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dateDialog.save(date)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
          <v-dialog
            ref="timeDialog"
            persistent
            v-model="timeDialog"
            lazy
            full-width
            width="fit-content"
            :return-value.sync="time"
            :disabled="disableTimeChangeIn"
          >
            <v-text-field
              slot="activator"
              label="Start Time"
              v-model="timeFormat"
              prepend-icon="access_time"
              readonly
              :rules="timeRules"              
              :disabled="disableTimeChangeIn"
            ></v-text-field>
            <b-timepicker
              inline
              size="is-large"
              placeholder="Click to select..."
              icon="clock"
              v-model="time"
              :time-parser="formatTimeStringToDate"
              :time-format="formatTimeDateToString"
              hour-format="24">
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="timeDialog = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.timeDialog.save(time)">OK</v-btn>
          </b-timepicker>
          </v-dialog>
          <v-combobox
            label="Load Numbers"
            v-model="load"
            prepend-icon="local_shipping"
            ref="loadSelect"
            chips
            multiple
            clearable
            deletable-chips
            color="primary"
            v-if="modules.pod"
          >
          </v-combobox>
          <v-checkbox
            v-if="extra_shift"
            v-model="isExtraShift"
            label = 'Is this an extra shift?'
          />
          <v-checkbox
            v-if="on_call"
            v-model="isOnCall"
            label = 'Is this an "on call" shift?'
          />
          <v-checkbox
            v-if="occasional_driver"
            v-model="occasionalDriving"
            label = 'Occasional Driving?'
          />
          <v-textarea
            label="Notes"
            v-model="notes"
            maxlength="255"
          />
          <v-btn class="primary" :loading="loading || !gpsAttemptComplete" block @click="submitClockIn" :disabled="!formValid">Confirm Start</v-btn>
        </v-form>
        <h1>{{gpsStatus}}</h1>
      </v-container>
    </v-card>
    <Disclaimer-Dialog :show-dialog.sync="displayDisclaimer" @declined="disclaimerAction"></Disclaimer-Dialog>
  </v-container>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import dbPromise from '../dbPromise'

export default {
  data () {
    return {
      url: this.$store.getters.url,
      dateDialog: false,
      date: null,
      timeDialog: false,
      time: null,
      timeFormat: null,
      load: [],
      completeDialog: false,
      errorDialog: false,
      errorDateDialog: false,
      modules: this.$store.getters.user.modules,
      empID: this.$store.getters.user.empID,
      occasionalDriving: false,
      isOnCall: false,
      isExtraShift: false,
      occasional_driver: this.$store.getters.user.occasional_driver,
      extra_shift: this.$store.getters.user.extra_shift,
      on_call: this.$store.getters.user.on_call,
      company: this.$store.getters.company,
      clockInFlagLimit: this.$store.getters.clockInFlagLimit,
      disableTimeChangeIn: this.$store.getters.disableTimeChangeIn,
      loading: false,
      gps: null,
      loadIdRules: [
        v => (v.length < 19) || 'Maximum length exceeded'
      ],
      notes: '',
      formValid: true,
      displayDisclaimer: true,
      clockInLimit: this.$store.getters.clockInLimit,
      gpsStatus: '',
      gpsAttemptComplete: false,
      geoClock: '0'
    }
  },
  created () {
    this.date = moment().format('YYYY-MM-DD')
    this.time = moment().toDate()
    if (this.$store.getters.disclaimerText === '' || this.$store.getters.disclaimerText === false || this.$store.getters.disclaimerText === undefined) {
      this.displayDisclaimer = false
    } else {
      this.displayDisclaimer = !this.$store.getters.disclaimerAccepted
    }
  },
  mounted () {
    if (localStorage.getItem('lat') && localStorage.getItem('long')) {
      this.gps = localStorage.getItem('lat') + ' ' + localStorage.getItem('long')
      this.gpsAttemptComplete = true
      this.gpsStatus = 'Using Static Machine GPS'
    } else if (navigator.geolocation) {
      this.gpsStatus = 'Getting GPS'
      navigator.geolocation.getCurrentPosition(position => {
        this.gpsStatus = 'GPS Acquired'
        this.gpsAttemptComplete = true
        this.gps = position.coords.latitude + ' ' + position.coords.longitude
      }, error => {
        this.gpsStatus = 'GPS Error'
        this.gpsAttemptComplete = true
        console.log(error)
      },
      {enableHighAccuracy: false, timeout: 5000, maximumAge: 0})
    } else {
      this.gpsAttemptComplete = true
      this.gpsStatus = 'GPS not available on this machine.'
    }
    this.$store.dispatch('checkLoginTime')
  },
  watch: {
    time: function (value) {
      this.timeFormat = moment(new Date(value)).format('HH:mm')
    }
  },
  computed: {
    formatDate () {
      return moment(this.date).format('DD/MM/YYYY')
    },
    timeRules () {
      let arr = []
      if (this.clockInLimit > -1) {
        arr.push(v => (moment(this.date + ' ' + this.timeFormat, 'YYYY-MM-DD HH:mm').isSameOrAfter(moment().subtract(this.clockInLimit, 'minutes'), 'minute')) || 'Clocking in, in the past is not allowed')
      }
      return arr
    }
  },
  methods: {
    submitClockIn () {
      console.log(this.gps)
      if (this.$refs.loadSelect) {
        this.$refs.loadSelect.blur()
      }
      this.$nextTick(() => {
        if (this.$refs.form.validate()) {
          this.loading = true
          let start = this.date + ' ' + moment(this.timeFormat, 'HH:mm').format('HH:mm')
          if (this.emp !== '' && this.company !== '') {
            let delayedStart = 0
            if (this.clockInFlagLimit && this.clockInFlagLimit > -1) {
              const diff = moment().diff(moment(start, 'YYYY-MM-DD HH:mm'), 'minutes')
              if (diff > this.clockInFlagLimit) {
                delayedStart = 1
              }
            }
            let postObj = {
              emp: this.empID,
              company: this.company,
              type: 'in',
              data: {
                start: start,
                load_array: this.load,
                gps: this.gps,
                notes: this.notes,
                occasional_driving: this.occasionalDriving * 1,
                extra_shift: this.isExtraShift * 1,
                on_call: this.isOnCall * 1
              },
              delayed_start: delayedStart
            }
            axios.post(this.url + `/tanda-service/saveShiftsForEmp.ajax.php`, postObj)
              .then(response => {
                console.log(response)
                if (response.data > 0) {
                  this.loading = false
                  this.completeDialog = true
                  this.addNewClockIn(start)
                } else if (response.data === 'You Are Not Within A Suitable Location' || response.data === 'Invalid GPS format' || response.data === 'Invalid GPS coordinates') {
                  alert(response.data)
                  this.loading = false
                } else {
                  this.loading = false
                  this.errorDateDialog = true
                }
              })
              .catch(error => {
                this.loading = false
                this.errorDialog = true
                console.log(error)
              })
          }
        }
      })
    },
    addNewClockIn (start) {
      let timesheet = [...this.$store.getters.timesheet]
      let newObj = {start: start, notes: this.notes}
      timesheet.push(newObj)

      dbPromise().then((db) => {
        let tx = db.transaction('timesheet-archive', 'readwrite')
        let timesheetStore = tx.objectStore('timesheet-archive')
        timesheetStore.put(timesheet, this.empID)
        return tx.complete
      }).then(() => {
        console.log('data saved locally')
      })
    },
    saveLocally (data) {
      dbPromise().then((db) => {
        let tx = db.transaction('outbox-timesheets', 'readwrite')
        let timesheetStore = tx.objectStore('outbox-timesheets')
        timesheetStore.put(data)
        return tx.complete
      }).then(() => {
        console.log('data saved locally')
      })
    },
    formatTimeStringToDate () {
      return moment(this.time, 'HH:mm').toDate()
    },
    formatTimeDateToString () {
      return moment(this.time).format('HH:mm')
    },
    disclaimerAction () {
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ClockInComponent.vue